<template>
  <el-dialog
    v-model="dialogvueqr"
    append-to-body
    class="noPaddingDialog"
    width="520px"
    :before-close="dialogvueqrClose"
  >
    <div style="text-align: center">
      <div
        style="padding: 20px 0 0; font-size: 20px"
        v-if="vueqrval.customTitle"
      >
        {{ vueqrval.customTitle }}
      </div>
      <vue-qrcode 
        :value="vueqrval" 
        :options="{
          width: 480
        }"
      />
    </div>
  </el-dialog>
</template>

<script>
import { axiosBase } from "@/api/api";
import { logobase64 } from "@/api/global.js";
import {
  lookqrcoreddata
} from "@/port/clientSide/oaExamineAudit";
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  name: 'vueqrComp',
  components: {
    VueQrcode
  },
  data () {
    return {
      dialogvueqr: false,
      vueqrval: '',
      vueqrTimeout: null,
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
  },
  methods: {
    //二维码生成方式
    onQrcodeCommand (command) {
      let commands = command
      if (command.type == 1) {//静态二维码
        this.onqrcoreddata(command)
        clearTimeout(this.vueqrTimeout)
      } else if (command.type == 2) {//动态二维码
        let self = this
        self.onqrcoreddata(command)
        self.vueqrTimeout = setTimeout(function () {
          self.onQrcodeCommand(commands)
        }, 10000);
      }
    },
    dialogvueqrClose () {
      this.dialogvueqr = false;
      clearTimeout(this.vueqrTimeout)
    },
    async onqrcoreddata (command) {
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        command.spaceid = spaceId;
      }
      else if(this.isUpace){
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        command.upaceid = upaceId;
      }
      if (command.mode === 'look') {
        this.generateLookQrcode(command)
        return false
      }
      axiosBase(command, "/openapi/qrcoreddata").then(res => {
        if (res.code === 0) {
          this.dialogvueqr = true;
          if(command.channel == "h5"){
            if(this.$apiurl == "http://app.itgedu.com.cn" || this.$apiurl == "http://10.66.99.244" || this.$apiurl == "http://10.66.99.244:8088"){              
              // 从空间进入，需要传空间id
              if(this.isSpace){
                let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
                this.vueqrval = 'https://admin.itgedu.com.cn:6352/page/scanapp/scanapp?code=' + res.data + '&spaceid=' + spaceId
              }
              else if(this.isUpace){
                let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
                this.vueqrval = 'https://admin.itgedu.com.cn:6352/page/scanapp/scanapp?code=' + res.data + '&upaceid=' + upaceId
              }
              else{
                this.vueqrval = 'https://admin.itgedu.com.cn:6352/page/scanapp/scanapp?code=' + res.data
              }
            }
            else{
              // 从空间进入，需要传空间id
              if(this.isSpace){
                let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
                this.vueqrval = this.$hfurl + '/page/scanapp/scanapp?code=' + res.data + '&spaceid=' + spaceId
              }
              else if(this.isUpace){
                let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
                this.vueqrval = this.$hfurl + '/page/scanapp/scanapp?code=' + res.data + '&upaceid=' + upaceId
              }
              else{
                this.vueqrval = this.$hfurl + '/page/scanapp/scanapp?code=' + res.data
              }
            }
          }
          else{
            // 阿里福州十八中跳转智慧轻校园小程序
            if(this.$apiurl == "https://user.topeti.com" && this.getUserMsgSchoolId() == '5057'){
              // 从空间进入，需要传空间id
              if(this.isSpace){
                let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
                this.vueqrval = { ...this.vueqrval, keys: this.$apiurl + '/static/getscanapp?from=new&code=' + res.data + '&spaceid=' + spaceId, customTitle: command.customTitle }
              }
              else if(this.isUpace){
                let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
                this.vueqrval = { ...this.vueqrval, keys: this.$apiurl + '/static/getscanapp?from=new&code=' + res.data + '&upaceid=' + upaceId, customTitle: command.customTitle }
              }
              else{
                this.vueqrval = { ...this.vueqrval, keys: this.$apiurl + '/static/getscanapp?from=new&code=' + res.data, customTitle: command.customTitle }
              }
            }
            else{
              // 从空间进入，需要传空间id
              if(this.isSpace){
                let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
                this.vueqrval = this.$apiurl + '/static/getscanapp?code=' + res.data + '&spaceid=' + spaceId
              }
              else if(this.isUpace){
                let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
                this.vueqrval = this.$apiurl + '/static/getscanapp?code=' + res.data + '&upaceid=' + upaceId
              }
              else{
                this.vueqrval = this.$apiurl + '/static/getscanapp?code=' + res.data
              }
              
            }
          }
        }
      });
    },
    // 生成查看二维码
    async generateLookQrcode (command) {
      const obj = { 
        approvalId: command.approvalId, 
        userapprovingId: command.userApprovingId,
        approvingId: command.approvingId,
        upaceid: command.upaceid,
        spaceid: command.spaceid,
      }
      const { code, data } = await lookqrcoreddata(obj)
      if (code === 0) {
        this.dialogvueqr = true;
        const itgeduUrl = ["http://app.itgedu.com.cn", "http://10.66.99.244", "http://10.66.99.244:8088"]
        if(command.channel == "h5"){
          if(itgeduUrl.includes(this.$apiurl)){              
            this.vueqrval = `https://admin.itgedu.com.cn:6352/page/scanapp/scanapp?code=${data}&mode=look`
          } else{
            this.vueqrval = this.$hfurl + `/page/scanapp/scanapp?code=${data}&mode=look`
          }
        }else{
          // 阿里福州十八中跳转智慧轻校园小程序
          if(this.$apiurl == "https://user.topeti.com" && this.getUserMsgSchoolId() == '5057'){
            this.vueqrval = { ...this.vueqrval, keys: this.$apiurl + `/static/getscanapp?from=new&code=${data}&mode=look`, customTitle: command.customTitle }
          }
          else{
            this.vueqrval = { ...this.vueqrval, keys: this.$apiurl + `/static/getscanapp?code=${data}&mode=look`, customTitle: command.customTitle }
          }
        }
      }
    },
    getUserMsgSchoolId () {
      const userMsg = localStorage.getItem('userMsg')
      return JSON.parse(userMsg).schoolMsg.schoolId
    },
  },
  mounted () {
    let testVal = logobase64()
    testVal.then(res => {
      this.vueqrval = res
    })
  }
}
</script>
<style lang="scss" scoped>
</style>
